import { filter, take } from 'rxjs/operators';
import { Component } from '@angular/core';
import { ProfileService } from '../profile/providers/profile.service';
import { Observable } from 'rxjs';
import { Profile } from '../profile/store/profile.entity';
import { NgxPermissionsService } from 'ngx-permissions';
import { PatientusRole } from '../auth/auth.roles';
import {
    APPOINTMENT_MULTIUSER_REQUESTS,
    APPOINTMENT_OVERVIEW_MULTIUSER_ROUTE,
    APPOINTMENT_OVERVIEW_REQUESTS,
    APPOINTMENT_OVERVIEW_ROUTE,
    SETTING_PROFILE,
    TAN_APPOINTMENT_ROUTE,
    WAITINGROOM_ROUTE
} from '../../routes';
import { RouterHelperService } from '../utils/router-helper/router-helper.service';
import { SurvicateService } from '../../providers/survicate/survicate.service';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { FeatureFlagService } from '../feature-flag/providers/feature-flag.service';
import { FeatureFlag } from '../feature-flag/feature-flag.types';
import { AppointmentRequestService } from '../appointment-request/providers/appointment-request.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [TranslatePipe, RouterLink, AsyncPipe]
})
export class DashboardComponent {
    public profileData$: Observable<Profile>;
    public createRoute = TAN_APPOINTMENT_ROUTE;
    public settingsRoute = SETTING_PROFILE;
    public overviewRoute = APPOINTMENT_OVERVIEW_ROUTE;
    public requestsRoute = APPOINTMENT_OVERVIEW_REQUESTS;
    public openRequests$: Observable<number>;

    constructor(private profileService: ProfileService,
                private permissionsService: NgxPermissionsService,
                private router: RouterHelperService,
                private survicateService: SurvicateService,
                private featureFlagService: FeatureFlagService,
                private appointmentRequestService: AppointmentRequestService) {
        this.profileData$ = this.profileService.getCurrentProfileDataObserver();
        if (this.featureFlagService.isFeatureEnabled(FeatureFlag.MULTI_USER_CALL)) {
            this.overviewRoute = APPOINTMENT_OVERVIEW_MULTIUSER_ROUTE;
            this.requestsRoute = APPOINTMENT_MULTIUSER_REQUESTS;
        }
        this.openRequests$ = this.appointmentRequestService.getNumberOfOpenAppointmentRequests();
        this.getCurrentRole();
    }

    async showFeedbackSurvey(): Promise<void> {
        await this.survicateService.showFeedbackSurvey()
    }

    private getCurrentRole(): void {
        this.permissionsService.permissions$.pipe(filter(p => Object.keys(p).length > 0),
            take(1)
        ).subscribe(p => {
                if (p[PatientusRole.PATIENT]) {
                    this.router.navigate([WAITINGROOM_ROUTE]);
                }
            }
        );
    }
}
